import script from "./EditableTable.vue?vue&type=script&setup=true&lang=js"
export * from "./EditableTable.vue?vue&type=script&setup=true&lang=js"

import "./EditableTable.vue?vue&type=style&index=0&id=0a1b8d0d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a1b8d0d"]])

export default __exports__